import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const eboard = new Restful(project, 'eboard')

eboard.checkEmail = (email, data) => {
  const url = project + 'eboard/email/' + email
  return http.get(url, data).then(res => {
    return res
  })
}

eboard.import = function(data) {
  const url = project + 'eboard/import'
  return http.put(url, data).then(res => {
    return res
  })
}

const eboardApply = new Restful(project, 'eboard/apply')

eboardApply.accepted = (id, data) => {
  const url = project + 'eboard/apply/accepted/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

eboardApply.acceptedById = (id, data) => {
  const url = project + 'eboard/apply/refuse/byId/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

export { eboard, eboardApply }
export default eboard
